import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('smurf account: henry@peachmango.com:::abc.12345');
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
